import { formatFloatNumber } from '@UIComponents/utils/formatters';
import './ViewershipInfoRow.scss';

const cbn = 'viewership-info-row';

type ViewershipInfoRowProps = {
  readonly dataCy?: string;
  readonly label: string;
  readonly value?: string | number;
  readonly className?: string;
};

function ViewershipInfoRow({
  dataCy,
  label,
  value,
  className,
}: ViewershipInfoRowProps) {
  const isNumber = typeof value === 'number';
  const formattedValue = isNumber ? formatFloatNumber(value) : value;

  return (
    <section data-cy={dataCy} className={`${cbn} ${className ?? ''}`}>
      <span className={`${cbn}__label`}>{label}</span>
      <div className={`${cbn}__value-container`}>
        <span className={`${cbn}__value`}>{formattedValue}</span>
      </div>
    </section>
  );
}

export default ViewershipInfoRow;
